const getCSSValue = (variableName: string): string =>
	window.getComputedStyle(document.body).getPropertyValue(variableName);

export const fonts = {
	body: getCSSValue("--font-family"),
	header: getCSSValue("--font-family-header"),
} as const;
